import { useCallback } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import {
  Generate_ServicesID,
  Get_Val_By_ServiceKey,
  Next_serviceID,
  trim,
} from "../globalhelper/DynamicFormHelpers";
import {
  rerender,
  setDOCJSON,
  setDynamicOptionDone,
  updateDynamicOptionDone,
  setOrgIdConst,
  setStoreVals,
  updateAthenaStorage,
  updateValidationErrorByKey,
} from "../redux/DynamicForms/dynamicFormsActions";
import { showAlert } from "../redux/Common/commonActions";
import { postRequest } from "../globalhelper/helper";
import dayjs from "dayjs";


export const useCreateTransaction = () => {
  const createTransaction = (childrenNode) => {
    let CreationDetails = childrenNode.creation_info
    window.open(
      `/Dynamic_Forms?token=${CreationDetails.transaction_name}&action=create`,
      "_blank",
    );

  }
  return createTransaction;
};

export const useRefreshDependencies = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const dynamicOption = useDynamicOption();

  return useCallback((node, doneKey) => {
    const state = store.getState();
    const currentDynamicOptionDone = state.dynamicForms.dynamicOption_Done;
    let newDynamicOptionDone = { ...currentDynamicOptionDone };

    if (doneKey) {
      delete newDynamicOptionDone[doneKey];
    }

    if (node.child_dependency && node.child_dependency.length > 0) {
      node.child_dependency.forEach((dep) => {
        Object.keys(newDynamicOptionDone).forEach(dk => {
          if (dk.toString().includes(dep.toString())) {
            delete newDynamicOptionDone[dk];
          }
        });
      });
    }

    dispatch(setDynamicOptionDone(newDynamicOptionDone));
    dispatch(rerender(true));

    dynamicOption(node, doneKey);
  }, [dispatch, store, dynamicOption]);
}

export function useChangeValByserviceID() {
  const dispatch = useDispatch();
  const onChangeOperation = useOnChangeOperation();
  const store = useStore();
  const { onTaxPerChange, onChangeEventForBillingSummary } = useBillingSummaryHooks();

  const changeValByserviceID = useCallback(async (
    serviceID_or_Key,
    matchBy,
    key,
    val,
    changeAll, row = null
  ) => {
    const state = store.getState();
    const currentDocJson = state.dynamicForms.DOCJSON;
    const currentDynamicOptionDone = state.dynamicForms.dynamicOption_Done;

    const newDOCJSON = JSON.parse(JSON.stringify(currentDocJson));
    let newDynamicOptionDone = { ...currentDynamicOptionDone };
    let view = "";
    let found = false;
    let hasChanged = false;

    // Flags to delay execution until after dispatch
    let triggerTaxChange = false;
    let triggerBillingSummary = false;
    let triggeredServiceKey = null;

    const updateRecursive = (nodes) => {
      nodes.forEach((node) => {
        if (node?.view && serviceID_or_Key.includes(node?.serviceID)) {
          view = view === "" ? node?.view : view;
        }
        if (trim(node[matchBy]) === trim(serviceID_or_Key) && node.render === "true" && (!found || changeAll)) {

          found = true;
          if (node[key] !== val) {
            hasChanged = true;
            node[key] = val;

            if (node.FormatCheck && node.editable === 'true' && val !== "" && val !== null && val !== undefined && key === 'val') {

              console.log("Regex =", key, matchBy, val, node.FormatCheck, node.FormatCheck && (matchBy === 'serviceID' || matchBy === 'serviceKey'));

              const regex = new RegExp(node.FormatCheck);

              const isValid = regex.test(String(val).trim());

              console.log("Regex Result =", isValid);

              if (!isValid) {

                console.log("Dispatching Validation Error");

                dispatch(
                  updateValidationErrorByKey(
                    node.serviceID,
                    `${node.title} format is invalid`
                  )
                );
              } else {
                dispatch(
                  updateValidationErrorByKey(
                    node.serviceID,
                    ``
                  )
                );
              }
            }
            if (node.DateCheck && key === 'val') {
              let checkCase = node.DateCheck?.includes("_") ? node.DateCheck.split("_")[0] : node.DateCheck;

              // 1. Get the raw date value from the document
              let targetDateVal = node.DateCheck?.split("_")[1] ? Get_Val_By_ServiceKey(node.DateCheck?.split("_")[1], currentDocJson) : null;

              // 2. Wrap both in dayjs objects
              let dateA = dayjs(val);
              let dateB = targetDateVal ? dayjs(targetDateVal) : dayjs();

              // 3. Compare dateA against dateB
              let isAfter = dateA.isAfter(dateB, "day");
              let isBefore = dateA.isBefore(dateB, "day");

              switch (checkCase) {
                case "isNotFutureDate":
                  if (dayjs(val).isAfter(dayjs(), "day")) {
                    dispatch(
                      updateValidationErrorByKey(
                        node.serviceID,
                        "Future date is not allowed."
                      )
                    );
                  } else {
                    dispatch(updateValidationErrorByKey(node.serviceID, ""));
                  }
                  break;
                case "isAfter":
                  if (!isAfter && targetDateVal && dateA.isValid() && dateB.isValid() && !dateA.isSame(dateB, "day")) {
                    dispatch(
                      updateValidationErrorByKey(
                        node.serviceID,
                        `${node?.["serviceKey"]} should be after ${node.DateCheck.split("_")[1] || ''}`
                      )
                    );
                  }
                  break;
                case "isBefore":
                  if (!isBefore && targetDateVal && dateA.isValid() && dateB.isValid() && !dateA.isSame(dateB, "day")) {
                    dispatch(
                      updateValidationErrorByKey(
                        node.serviceID,
                        `${node?.["serviceKey"]} should be before ${node.DateCheck.split("_")[1] || ''}`
                      )
                    );
                  }
                  break;
                default:
                  dispatch(updateValidationErrorByKey(node.serviceID, ""));
                  break;
              }
            }
          }
          if (node.serviceKey === "Tax Percentage") {
            triggerTaxChange = true;
          }
          if (
            node.serviceKey === "Qty" ||
            node.serviceKey === "Rate"
          ) {
            triggerBillingSummary = true;
            triggeredServiceKey = node.serviceKey;
          }

          if (node.child_dependency && node.child_dependency.length > 0) {
            node.child_dependency.forEach((dep) => {
              Object.keys(newDynamicOptionDone).forEach(doneKey => {
                if (doneKey.includes(dep)) {
                  delete newDynamicOptionDone[doneKey];
                }
              });
            });
          }
        }
        if (node.children && (!found || changeAll)) {
          updateRecursive(node.children);
        }
      });
    };

    if (newDOCJSON && !found) {
      updateRecursive(newDOCJSON);
      if (hasChanged) {
        dispatch(setDOCJSON(newDOCJSON));
      }
      if (
        JSON.stringify(newDynamicOptionDone) !==
        JSON.stringify(currentDynamicOptionDone)
      ) {
        dispatch(setDynamicOptionDone(newDynamicOptionDone));
      }

      // Wait for React/Redux to process the synchronous state updates above
      await new Promise(resolve => setTimeout(resolve, 0));

      // Now execute dependent operations with the fully updated Redux state
      if (triggerTaxChange) {
        onTaxPerChange(val, row);
      }
      if (triggerBillingSummary && triggeredServiceKey) {
        onChangeEventForBillingSummary(triggeredServiceKey, val, row);
      }
    }
  }, [dispatch, store, onTaxPerChange, onChangeEventForBillingSummary]);

  return changeValByserviceID;
}

export const useDynamicOption = () => {
  const dispatch = useDispatch();
  const changeValByserviceID = useChangeValByserviceID();
  const store = useStore();

  return useCallback(async function dynamic_option_fn(childrenNode, doneKey) {
    try {
      const state = store.getState();
      const userData = state.login.userData;
      const DOCJSON = state.dynamicForms.DOCJSON;
      const dynamicOptionDone = state.dynamicForms.dynamicOption_Done;

      if (
        childrenNode?.editable === "false" &&
        childrenNode?.type !== "input"
      ) {
        return;
      }
      let directory = childrenNode?.dynamic_option?.api_Directory || "";
      let hit = `${directory}?query_Name=${childrenNode?.dynamic_option?.query_Name}&action=CommonAPI`;
      let array = [];
      let dependencyHash = "";
      if (childrenNode?.dynamic_option?.dynamic_query) {
        childrenNode?.dynamic_option?.dynamic_query?.forEach((each) => {
          let value = "";
          if (each.emailid) {
            value = userData?.USR_Email || "";
            array.push({
              replaceStringWith: each.replaceStringWith,
              value: value,
            });
          } else {
            value = Get_Val_By_ServiceKey(
              each.getValueFrom,
              DOCJSON
            ) || "";
            console.log(each.getValueFrom, childrenNode.serviceID.split("#")[0], value, "Value");

            array.push({
              replaceStringWith: each.replaceStringWith,
              value: value,
            });
          }
        });
      }

      if (doneKey) {
        dispatch(updateDynamicOptionDone({ key: doneKey, hash: dependencyHash }));
      }

      const res = await postRequest(
        hit,
        array?.length ? { info: array } : null
      );
      const DATA = JSON.parse(res?.res?.data);

      if (res?.res?.status === "success") {

        if (DATA?.length) {
          let matchKey = Object.keys(DATA[0]).find(
            (each) => trim(each) === trim(childrenNode?.serviceKey),
          );

          if (matchKey) {
            if (childrenNode?.dynamic_option?.what_to_store) {
              dispatch(
                updateAthenaStorage({
                  key: childrenNode.dynamic_option.what_to_store,
                  value: DATA,
                }),
              );
            }

            let newSet = [...new Set(DATA?.map((each) => each[matchKey]))];
            let options =
              newSet
                ?.filter(
                  (one) =>
                    one !== null &&
                    one !== undefined &&
                    String(one).trim() !== "",
                )
                .map((one) => {
                  return {
                    label: String(one),
                    value: String(one),
                  };
                }) || [];

            changeValByserviceID(
              childrenNode?.serviceID,
              "serviceID",
              "options",
              options,
              false
            );
            dispatch(rerender(false));
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [
    dispatch,
    changeValByserviceID,
    store
  ]);
};

export const useSearchDynamicOptions = () => {
  const userData = useSelector((state) => state.login.userData);
  const DOCJSON = useSelector((state) => state.dynamicForms.DOCJSON);
  let dispatch = useDispatch();
  const changeValByserviceID = useChangeValByserviceID();

  async function search_Dynamic_Options(
    childrenNode,
    setDialogData,
    DialogData
  ) {
    let obj = {};

    if (childrenNode?.api_info.dynamic_query) {
      for (const each of childrenNode?.api_info.dynamic_query) {
        if (each.emailid) {
          obj = {
            ...obj,
            [each.getValueFrom || "email"]: userData?.USR_Email,
          };
        } else {
          const name = each.getValueFrom;
          let value = Get_Val_By_ServiceKey(each.getValueFrom, DOCJSON, childrenNode.serviceID.split("#")[0]);
          obj = {
            ...obj,
            [name]: value,
          };
        }
      }
    }

    let hit = `${childrenNode?.api_info.api_Directory}?action=GetAllItemRef`;
    const { res } = await postRequest(
      hit,
      Object.keys(obj).length ? { info: obj } : null
    );
    const data = JSON.parse(res.data);

    if (res?.status === "success") {
      let DATA = data && data?.length ? data : [];

      if (childrenNode?.api_info.what_to_store) {
        dispatch(
          updateAthenaStorage({
            key: childrenNode.api_info.what_to_store,
            value: DATA,
          }),
        );
      }

      if (DATA?.length) {
        let matchKey = Object.keys(DATA[0]).find(
          (each) => trim(each) === trim(childrenNode?.serviceKey),
        );

        if (matchKey) {
          let newSet = [...new Set(DATA?.map((each) => each[matchKey]))];
          let options = newSet.map((one) => ({
            label: one,
            value: one,
          }));

          changeValByserviceID(
            childrenNode?.serviceID,
            "serviceID",
            "options",
            options,
            false
          );

          if (DialogData?.DialogData?.children) {
            setDialogData((prev) => ({
              ...prev,
              DialogData: {
                ...prev.DialogData,
                children: prev.DialogData.children.map((child) =>
                  child.serviceID === childrenNode?.serviceID
                    ? { ...child, options: options }
                    : child
                ),
              }
            }));
          }
          dispatch(rerender(false));
        }
      }
    }
  }
  return search_Dynamic_Options;
};

export const useTableCopyRow = () => {
  let dispatch = useDispatch();
  const DOCJSON = useSelector((state) => state.dynamicForms.DOCJSON);

  function tableCopyRow(obj, parentObj) {
    let Prev_serviceID = parentObj.serviceID;
    let OBJ = JSON.parse(JSON.stringify(obj));
    let parent_obj = JSON.parse(JSON.stringify(parentObj));
    parent_obj.title = Next_serviceID(parent_obj.title, 1);
    parent_obj.serviceID = Next_serviceID(parent_obj.serviceID, 1);
    parent_obj.serviceKey = Next_serviceID(parent_obj.serviceKey, 1);

    OBJ?.forEach((each, i) => {
      if (OBJ[i].serviceKey === "Line ID")
        OBJ[i].val = String(Number(OBJ[i].val) + 1);
      OBJ[i].serviceID = Next_serviceID(each.serviceID, 1);
    });
    parent_obj.children = OBJ;

    let found = false;
    let NEW_DOCJSON = JSON.parse(JSON.stringify(DOCJSON));
    NEW_DOCJSON?.forEach((each) => {
      if (found) return;
      if (each.children && each.children?.length) {
        each.children.forEach((each2) => {
          if (found) return;
          if (each2.view === "table" && each2.children && each2.children?.length) {
            const index = each2.children.findIndex((row) => row.serviceID === Prev_serviceID);
            if (index !== -1) {
              each2.children.splice(index + 1, 0, parent_obj);
              each2.children.forEach((each3, index) => {
                each3.title = Generate_ServicesID(each3.title, index);
                each3.serviceID = Generate_ServicesID(each3.serviceID, index);
                each3.serviceKey = Generate_ServicesID(each3.serviceKey, index);
                each3.children?.forEach((eachVal) => {
                  if (eachVal.serviceKey === "Line ID") {
                    eachVal.val = String(1 + index);
                  }
                  eachVal.serviceID = Generate_ServicesID(eachVal.serviceID, index);
                });
              });
              dispatch(setDOCJSON(NEW_DOCJSON));
              dispatch(rerender(true));
              found = true;
            }
          }
        });
      }
    });
  }
  return tableCopyRow;
};

export const useTableRowAdd = () => {
  const DOCJSON = useSelector((state) => state.dynamicForms.DOCJSON);
  let dispatch = useDispatch();

  function tableRowAdd(
    obj,
    parentObj,
    ROWNUM,
    setDialogData,
    confirmation = false,
    tableId,
    isEdit = false,
  ) {
    if (!confirmation) {
      let OBJ = JSON.parse(JSON.stringify(obj));
      let parent_obj = JSON.parse(JSON.stringify(parentObj));
      parent_obj.title = Next_serviceID(parent_obj.title, 1);
      parent_obj.serviceID = Next_serviceID(parent_obj.serviceID, 1);
      parent_obj.serviceKey = Next_serviceID(parent_obj.serviceKey, 1);

      OBJ?.forEach((each, i) => {
        if (OBJ[i].serviceKey === "Line ID")
          OBJ[i].val = String(Number(OBJ[i].val) + 1);
        else OBJ[i].val = "";
        OBJ[i].serviceID = Next_serviceID(each.serviceID, 1);
      });
      parent_obj.children = OBJ;
      console.log(parent_obj, ROWNUM, true, isEdit, tableId);

      setDialogData({
        DialogData: parent_obj,
        ROWNUM,
        open: true,
        isEdit,
        tableId,
      });
    } else {
      let found = false;
      let NEW_DOCJSON = JSON.parse(JSON.stringify(DOCJSON));
      NEW_DOCJSON?.forEach((each) => {
        if (found) return;
        if (each.children && each.children?.length) {
          each.children.forEach((each2) => {
            if (found) return;
            if (each2.children && each2.children?.length) {
              each2.children.forEach((each3) => {
                if (found) return;
                if (
                  each3?.serviceID?.includes("#") &&
                  parentObj?.serviceID?.includes("#") &&
                  each3?.serviceID?.split("#")?.slice(0, -1)[0] ===
                  parentObj?.serviceID?.split("#")?.slice(0, -1)[0]
                ) {
                  each2?.children?.push(parentObj);
                  dispatch(setDOCJSON(NEW_DOCJSON));
                  dispatch(rerender(true));
                  found = true;
                  setDialogData({
                    DialogData: null,
                    ROWNUM: 0,
                    open: false,
                    isEdit: false,
                    tableId: "",
                  });
                  return;
                }
              });
            }
          });
        }
      });
    }
  }
  return tableRowAdd;
};

export const useStoreVals = () => {
  const VALS = useSelector((state) => state.dynamicForms.storeVals);
  let dispatch = useDispatch();

  function store_all_vals(DOCJSON = null) {
    let newValS = { ...VALS };
    DOCJSON?.forEach((each) => {
      if (each.children && each.children?.length) {
        each.children?.forEach((each2) => {
          if (each2.children && each2.children?.length) {
            each2.children?.forEach((each3) => {
              if (!each3.children && each3.render === "true") {
                newValS[each3.serviceID] = each3.val;
              }
              if (each3.children && each3.children?.length) {
                each3.children?.forEach((each4) => {
                  if (each4.render === "true") {
                    newValS[each4.serviceID] = each4.val;
                  }
                });
              }
            });
          }
        });
      }
    });
    dispatch(setStoreVals(newValS));
  }
  return store_all_vals;
};

export const usePopupSelectFn = () => {
  const DOCJSON = useSelector((state) => state.dynamicForms.DOCJSON);
  let dispatch = useDispatch();

  async function popup_select_fn(
    childrenNode,
    setState,
    state
  ) {
    console.log("childrenNode", childrenNode);

    let obj = {};
    if (childrenNode.type === "popup_select") {
      obj["ORG_ID_CONST"] = Get_Val_By_ServiceKey('Organization ID', DOCJSON) || Get_Val_By_ServiceKey('Receiver ID', DOCJSON)
    }

    const SerKeys =
      childrenNode.type === "popup_select"
        ? localStorage.getItem('tenantID') === "TID00002"
          ? ["Vendor ID", "Invoice Ref"]
          : ["Vendor ID", "Vendor GST Number", "GST Number", "Invoice Ref"]
        : childrenNode.type === "popup_select_goods"
          ? ["Order Type", "Sender ID"]
          : [];

    for (const key of SerKeys) {
      console.log(key, SerKeys, "Keyyyyy");

      obj[key] = Get_Val_By_ServiceKey(key, DOCJSON);
    }

    if (Object.values(obj).some(item => !item)) {
      dispatch(showAlert(
        `${Object.keys(obj).find(key => !obj[key])} is required`,
        "error",
      ))
      return;
    }

    const hit = `${childrenNode?.api_info.api_Directory}?query_Name=${childrenNode?.api_info.query_Name}`;
    const { res } = await postRequest(hit, obj);
    const data = JSON.parse(res.data);
    console.log(res, "res", data);

    if (res?.status === "success") {
      let DATA = data && data?.length ? data : [];
      setState({
        ...state,
        open_popup: DATA.length > 0,
        popup_table: {
          search: "",
          data: DATA,
          filteredData: DATA,
          header: DATA.length ? Object.keys(DATA[0]) : [],
        },
      });
    }
  }
  return popup_select_fn;
};

export const useOnChangeOperation = () => {
  let dispatch = useDispatch();
  const athenaStorage = useSelector((state) => state.dynamicForms.athenaStorage);
  const changeValBy_row = useChangeValByRow();

  function onChangeOperation(
    childrenNode,
    val,
    index,
    view,
    changeValByserviceID
  ) {
    if (!childrenNode) return;
    if (view !== "table") {
      let ARRAY =
        (childrenNode?.onChange_operation?.get_From &&
          athenaStorage[childrenNode.onChange_operation.get_From]) ||
        [];

      let changeAll = !!childrenNode?.onChange_operation?.changeAll;
      if (ARRAY && ARRAY[0]) {
        let matchKey = Object.keys(ARRAY[0]).find(
          (each) => trim(each) === trim(childrenNode?.serviceKey),
        );

        if (matchKey && childrenNode?.type !== "multiselect") {
          let LINES = ARRAY.filter((each) => each[matchKey] === val);

          if (
            childrenNode?.onChange_operation?.operation === "show_next_dropdown"
          ) {
            let child_Name = childrenNode?.onChange_operation?.child_Name || "";
            if (typeof child_Name !== "object") {
              child_Name = [child_Name];
            }

            child_Name?.forEach((item) => {
              let OPTIONS = [];
              if (LINES?.length) {
                let newSet = [...new Set(LINES?.map((each) => each[item]))];
                OPTIONS = newSet?.map((each) => ({
                  label: each,
                  value: each,
                }));
                changeValByserviceID(item, "serviceKey", "options", OPTIONS, changeAll);
                dispatch(rerender(false));
              } else {
                changeValByserviceID(item, "serviceKey", "options", [], changeAll);
                dispatch(rerender(false));
              }
            });
          } else {
            if (LINES?.length === 1) {
              let LINE = LINES[0];
              Object.keys(LINE)?.forEach((one) => {
                if (one !== matchKey) {
                  changeValByserviceID(one, "serviceKey", "val", LINE[one], changeAll);
                  dispatch(rerender(true));
                }
              });
            }
          }
        }
      }
    } else {

      const serviceIdParts = childrenNode.serviceID.split("#");
      serviceIdParts.splice(1, 1);
      const storageKey = serviceIdParts.join("#");

      let ARRAY =
        (childrenNode?.onChange_operation?.get_From &&
          athenaStorage[childrenNode.onChange_operation.get_From]) ||
        [];

      if (athenaStorage[storageKey]) {
        ARRAY = athenaStorage[storageKey];
      }

      let matchKey =
        (ARRAY?.length &&
          Object.keys(ARRAY[0]).find(
            (each) => trim(each) === trim(childrenNode.serviceKey),
          )) ||
        null;

      if (matchKey) {
        let LINES = ARRAY?.filter((each) => each[matchKey] === val);
        if (
          childrenNode?.onChange_operation?.operation === "show_next_dropdown"
        ) {
          let child_Name = childrenNode?.onChange_operation?.child_Name || "";
          if (typeof child_Name !== "object") {
            child_Name = [child_Name];
          }

          child_Name?.forEach((item) => {
            let OPTIONS = [];
            if (LINES?.length) {
              let newSet = [...new Set(LINES?.map((each) => each[item]))];
              OPTIONS = newSet.map((each) => ({
                label: each,
                value: each,
              }));
              changeValBy_row(item, "serviceKey", "options", OPTIONS, index || 0);
              dispatch(rerender(false));
            } else {
              changeValBy_row(item, "serviceKey", "options", OPTIONS, index || 0);
              dispatch(rerender(false));
            }
          });
        } else {
          if (LINES?.length === 1) {
            let LINE = LINES[0];
            Object.keys(LINE)?.forEach((one) => {
              if (one !== matchKey) {
                changeValBy_row(one, "serviceKey", "val", LINE[one], index || 0);
                dispatch(rerender(true));
              }
            });
          }
        }
      }
    }
  }
  return onChangeOperation;
};

export const useChangeValByRow = () => {
  const store = useStore();
  const dispatch = useDispatch();

  const changeValByRow = (
    serviceID_or_Key,
    matchBy,
    key,
    val,
    rowNO
  ) => {
    const state = store.getState();
    const DOCJSON = state.dynamicForms.DOCJSON;
    const newDOCJSON = JSON.parse(JSON.stringify(DOCJSON));
    let found = false;

    newDOCJSON?.forEach((each) => {
      if (found) return;
      each.children?.forEach((each2) => {
        if (found) return;
        if (each2.children && each2.children[rowNO] && each2.children[rowNO].children) {
          each2.children[rowNO].children.forEach((each4) => {
            if (found) return;
            if (each4.render === "true" && trim(each4[matchBy]) === trim(serviceID_or_Key)) {
              each4[key] = val;
              found = true;
            }
          });
        }
      });
    });

    if (found) {
      dispatch(setDOCJSON(newDOCJSON));
    }
  };
  return changeValByRow;
};

export const useTableDelRow = () => {
  const dispatch = useDispatch();
  const DOCJSON = useSelector((state) => state.dynamicForms.DOCJSON);

  function tableDelRow(serviceID) {
    let NEW_DOCJSON = JSON.parse(JSON.stringify(DOCJSON));
    let found = false;

    NEW_DOCJSON?.forEach((each) => {
      if (found) return;
      each.children?.forEach((each2) => {
        if (found) return;
        if (each2.view === "table" && each2.children?.length) {
          const index = each2.children.findIndex((row) => row.serviceID === serviceID);
          if (index !== -1) {
            each2.children.splice(index, 1);
            // Re-index remaining rows
            each2.children.forEach((each3, idx) => {
              each3.title = Generate_ServicesID(each3.title, idx);
              each3.serviceID = Generate_ServicesID(each3.serviceID, idx);
              each3.serviceKey = Generate_ServicesID(each3.serviceKey, idx);
              each3.children?.forEach((eachVal) => {
                if (eachVal.serviceKey === "Line ID") {
                  eachVal.val = String(1 + idx);
                }
                eachVal.serviceID = Generate_ServicesID(eachVal.serviceID, idx);
              });
            });
            dispatch(setDOCJSON(NEW_DOCJSON));
            dispatch(rerender(true));
            found = true;
          }
        }
      });
    });
  }
  return tableDelRow;
};

export const usePutDefaultValue_BillExtract = () => {
  const dispatch = useDispatch();
  const DOCJSON = useSelector((state) => state.dynamicForms.DOCJSON);

  const putDefaultValue_BillExtract = (KEY, VAL) => {
    let VR2_Form_Json = DOCJSON;
    let found = false;

    VR2_Form_Json?.forEach((each, i) => {
      if (found) return;
      if (each.children && each.children.length) {
        each.children.forEach((each2, j) => {
          if (found) return;
          if (each2.children && each2.children.length) {
            each2.children.forEach((each3, k) => {
              if (found) return;

              if (
                !each3.children &&
                each3.render &&
                each3.render === "true" &&
                each3.serviceKey === KEY
              ) {
                if (!each3.val) {
                  each3.val = VAL;
                  dispatch(setDOCJSON(VR2_Form_Json));
                }

                found = true;
                return;
              }
            });
          }
        });
      }
    });
  }
  return putDefaultValue_BillExtract;
};

export const useBillingSummaryHooks = () => {
  const store = useStore();
  const dispatch = useDispatch();

  const changeValBy_row = useCallback(
    (serviceID_or_Key, matchBy, key, val, rowNO) => {
      console.log(serviceID_or_Key, matchBy, key, val, rowNO, "serviceID_or_Key", "matchBy", "key", "val", "rowNO");
      const state = store.getState();
      const DOCJSON = state.dynamicForms.DOCJSON;
      let NEW_DOCJSON = JSON.parse(JSON.stringify(DOCJSON));
      const token = state.dynamicForms.token || "";
      let found = false;

      NEW_DOCJSON?.forEach((each) => {
        if (found) return;
        if (each.children && each.children?.length) {
          each.children.forEach((each2) => {
            if (found) return;
            if (
              each2.children &&
              each2.children?.length &&
              each2.children[rowNO] &&
              each2.children[rowNO].children
            ) {
              each2.children[rowNO].children.forEach((each4) => {
                if (found) return;
                if (
                  each4?.render === "true" &&
                  trim(each4[matchBy]) === trim(serviceID_or_Key)
                ) {
                  if (
                    (token === "BillExtract" ||
                      token === "GoodsAndServicesEntries") &&
                    (each4.serviceKey === "Item ID" ||
                      each4.serviceKey === "ForPrdFrom" ||
                      each4.serviceKey === "ForPrdTo")
                  ) {
                    // costAllocationMethod(rowNO, each4.serviceKey, val); // To be implemented or passed as needed
                  }

                  each4[key] = val;
                  dispatch(setDOCJSON(NEW_DOCJSON));
                  found = true;

                  return;
                }
              });
            }
          });
        }
      });
    },
    [store, dispatch]
  );

  const onTaxPerChange = useCallback(
    (Tax_Percentage, rowNO) => {
      let Tax_Category;
      let BaseValue;
      const state = store.getState();
      let VR2_Form_Json = state.dynamicForms.DOCJSON;
      let found = false;
      console.log(Tax_Percentage, rowNO);

      VR2_Form_Json?.forEach((each) => {
        if (found) return;
        if (each.children && each.children?.length) {
          each.children.forEach((each2) => {
            if (found) return;
            if (each2.children && each2.children?.length) {
              each2.children.forEach((each3) => {
                if (found) return;

                if (
                  !each3.children &&
                  each3?.render &&
                  each3?.render === "true" &&
                  each3.serviceKey === "Tax Category"
                ) {
                  Tax_Category = each3.val;
                } else if (each3.children && each3.children?.length) {
                  each3.children.forEach((each4) => {
                    if (found) return;
                    if (
                      !each4.children &&
                      each4?.render &&
                      each4?.render === "true" &&
                      each4.serviceKey === "Base Value" &&
                      each4.serviceID.includes("billingsummary")
                    ) {
                      BaseValue =
                        typeof Number(each4.val) == "NaN" ? 0 : each4.val;
                      found = true;
                    }
                  });
                }
              });
            }
          });
        }
      });

      if (!BaseValue) return;

      let taxCode =
        typeof Number(Tax_Percentage) == "NaN"
          ? 0
          : Tax_Category + " " + String(Number(Tax_Percentage)) + "%";
      let totaltaxvalue = (
        (Number(Tax_Percentage) * Number(BaseValue)) /
        100
      ).toFixed(2);

      changeValBy_row("Tax Code", "serviceKey", "val", taxCode, rowNO);
      changeValBy_row("Tax Value", "serviceKey", "val", totaltaxvalue, rowNO);
      changeValBy_row(
        "Total Value",
        "serviceKey",
        "val",
        (Number(BaseValue) + Number(totaltaxvalue)).toFixed(2),
        rowNO
      );

      if (taxCode.includes("IGST")) {
        changeValBy_row(
          "IGST Percentage",
          "serviceKey",
          "val",
          Number(Tax_Percentage).toFixed(2),
          rowNO
        );
        changeValBy_row("IGST", "serviceKey", "val", totaltaxvalue, rowNO);
        changeValBy_row(
          "CGST Percentage",
          "serviceKey",
          "val",
          0,
          rowNO
        );
        changeValBy_row(
          "CGST",
          "serviceKey",
          "val",
          0,
          rowNO
        );
        changeValBy_row(
          "SGST Percentage",
          "serviceKey",
          "val",
          0,
          rowNO
        );
        changeValBy_row(
          "SGST",
          "serviceKey",
          "val",
          0,
          rowNO
        );
        return;
      }
      changeValBy_row(
        "CGST Percentage",
        "serviceKey",
        "val",
        (Number(Tax_Percentage) / 2),
        rowNO
      );
      changeValBy_row(
        "CGST",
        "serviceKey",
        "val",
        (Number(totaltaxvalue) / 2).toFixed(2),
        rowNO
      );
      changeValBy_row(
        "SGST Percentage",
        "serviceKey",
        "val",
        (Number(Tax_Percentage) / 2),
        rowNO
      );
      changeValBy_row(
        "SGST",
        "serviceKey",
        "val",
        (Number(totaltaxvalue) / 2).toFixed(2),
        rowNO
      );
      changeValBy_row(
        "IGST Percentage",
        "serviceKey",
        "val",
        0,
        rowNO
      );
      changeValBy_row("IGST", "serviceKey", "val", 0, rowNO);
    },
    [store, changeValBy_row]
  );

  const onChangeEventForBillingSummary = useCallback(
    (ServicesKey, Val, rowNO) => {
      let Obj = {
        [ServicesKey]: Val,
        "Tax Percentage": null,
        "Tax Category": null,
      };

      const state = store.getState();
      let VR2_Form_Json = state.dynamicForms.DOCJSON;
      let found = false;

      VR2_Form_Json?.forEach((each) => {
        if (found) return;
        if (each.children && each.children?.length) {
          each.children.forEach((each2) => {
            if (found) return;
            if (each2.children && each2.children?.length) {
              each2.children.forEach((each3) => {
                if (found) return;

                if (
                  !each3.children &&
                  each3?.render &&
                  each3?.render === "true" &&
                  each3.serviceKey === "Tax Category"
                ) {
                  Obj = { ...Obj, "Tax Category": each3.val };
                } else if (each3.children && each3.children?.length) {
                  each3.children.forEach((each4) => {
                    if (found) return;

                    if (
                      !each4.children &&
                      each4?.render &&
                      each4?.render === "true" &&
                      (each4.serviceKey === "Qty" ||
                        each4.serviceKey === "Rate" ||
                        each4.serviceKey === "Tax Percentage") &&
                      each4.serviceID.includes("billingsummary")
                    ) {
                      Obj = {
                        ...Obj,
                        "Tax Percentage":
                          each4.serviceKey === "Tax Percentage"
                            ? typeof Number(each4.val) == "NaN"
                              ? 0
                              : each4.val
                            : null,
                      };
                      const isQtyOrRate =
                        ServicesKey === "Qty" ? "Rate" : "Qty";

                      Obj = {
                        ...Obj,
                        [isQtyOrRate]:
                          each4.serviceKey === isQtyOrRate
                            ? Number.isNaN(each4.val)
                              ? 0
                              : each4.val
                            : Obj[isQtyOrRate] || null,
                      };

                      found = Object.values(Obj).every(
                        (val) => val !== null
                      );
                    }
                  });
                }
              });
            }
          });
        }
      });

      if (!found) return;
      let BaseValue = (Number(Obj["Rate"]) * Number(Obj["Qty"])).toFixed(2);
      let totaltaxvalue = (
        (Number(Obj["Tax Percentage"]) * Number(BaseValue)) /
        100
      ).toFixed(2);

      changeValBy_row("Tax Value", "serviceKey", "val", totaltaxvalue, rowNO);
      changeValBy_row(
        "Total Value",
        "serviceKey",
        "val",
        (Number(BaseValue) + Number(totaltaxvalue)).toFixed(2),
        rowNO
      );
      changeValBy_row(
        "Base Value",
        "serviceKey",
        "val",
        Number(BaseValue).toFixed(2),
        rowNO
      );

      if (Obj["Tax Category"].includes("IGST")) {
        changeValBy_row("IGST", "serviceKey", "val", totaltaxvalue, rowNO);
        return;
      }

      changeValBy_row(
        "CGST",
        "serviceKey",
        "val",
        (Number(totaltaxvalue) / 2).toFixed(2),
        rowNO
      );
      changeValBy_row(
        "SGST",
        "serviceKey",
        "val",
        (Number(totaltaxvalue) / 2).toFixed(2),
        rowNO
      );
    },
    [store, changeValBy_row]
  );

  return { changeValBy_row, onTaxPerChange, onChangeEventForBillingSummary };
};

export const useInputSelectFn = () => {
  const store = useStore();
  const dispatch = useDispatch();

  const input_select_fn = async (
    childrenNode,
    setState,
    state,
    on_popup_table_search,
    tableRow_click
  ) => {
    const currentState = store.getState();
    const DOCJSON = currentState.dynamicForms.DOCJSON;
    const ORG_ID_CONST =
      currentState.dynamicForms.ORG_ID_CONST ||
      currentState.VR2?.ORG_ID_CONST ||
      "";

    // To support 'this.state.Give_Val_By_ServiceKey' logic from VR2

    console.log(childrenNode, "billooo");
    let hit = `${childrenNode.api_info.api_Directory}`;

    let VendorPAN = Get_Val_By_ServiceKey("Vendor PAN", DOCJSON);

    let VendorGSTNumber = Get_Val_By_ServiceKey("Vendor GST Number", DOCJSON);

    let GSTNumber = Get_Val_By_ServiceKey("GST Number", DOCJSON);

    let OrgID = ORG_ID_CONST || Get_Val_By_ServiceKey("Organization ID", DOCJSON) || Get_Val_By_ServiceKey("Recevier ID", DOCJSON);

    let input = {
      VendorName: childrenNode.val,
      VendorPAN,
      VendorGSTNumber,
      GSTNumber, //mbp---uncmtd
      OrgID,
    };

    if (Object.values(input).some((item) => item === "" || item === null || item === undefined)) {
      console.log(hit, "billooo");
      store.dispatch(showAlert(`${Object.keys(input).join(", ")} are required`, "error"));
      return;
    }

    postRequest(hit, input).then((res) => {
      if (res.res.status === "success") {
        let DATA =
          res.res.data && res.res.data?.length ? JSON.parse(res.res.data) : [];

        if (DATA?.length) {
          // Simulating functional state update
          setState(prev => ({
            ...prev,
            open_popup: true,
            popup_table: {
              search: "",
              data: DATA,
              filteredData: DATA,
              header: Object.keys(DATA[0]),
            },
          }));

          // Logic from original setState callback
          let popup_table = {
            search: "",
            data: DATA,
            filteredData: DATA,
            header: Object.keys(DATA[0]),
          };

          if (
            popup_table &&
            popup_table.data?.length &&
            popup_table.data?.length === 1
          ) {
            if (tableRow_click) tableRow_click(popup_table.data[0]);
          } else if (popup_table && popup_table.data?.length) {
            let e = {
              target: {
                value: childrenNode.val,
              },
            };

            if (on_popup_table_search) on_popup_table_search(e);
          }
        }
      }
    });
  };
  return input_select_fn;
}